import {
  advancedFormArray, advancedFormControl, advancedFormGroup,
  FormControlTypeEnum,
} from '@magieno/common';
import { IncomeTaxPersonalChildOptions } from './income-tax-personal-child.options';
import { IncomeTaxPersonalSpouseOptions } from './income-tax-personal-spouse.options';

import { validateIf, ValidateNested } from '@pristine-ts/class-validator';
import { translationBaseKey } from '../../../../../decorators/translation-base-key.decorator';
import { CalculationRunOptions } from '../../../calculation-run.options';
import { CalculationKeynameEnum } from '../../../../../enums/calculations/calculation-keyname.enum';
import { array } from '@pristine-ts/data-mapping-common';
import { IncomeTaxPersonalCommonOptions } from '../common/income-tax-personal-common.options';

@translationBaseKey('income-tax-personal-options')
export class IncomeTaxPersonalOptions extends IncomeTaxPersonalCommonOptions implements CalculationRunOptions {
  @advancedFormControl({
    type: FormControlTypeEnum.Hidden,
  })
  calculationKeyname: CalculationKeynameEnum = CalculationKeynameEnum.IncomeTaxPersonal;

  @advancedFormGroup({
    classType: IncomeTaxPersonalSpouseOptions,
  })
  @ValidateNested()
  override mainPerson: IncomeTaxPersonalSpouseOptions = new IncomeTaxPersonalSpouseOptions();

  @advancedFormGroup({
    classType: IncomeTaxPersonalSpouseOptions,
  })
  @validateIf((options: IncomeTaxPersonalOptions) => {
    return options.isMarried === true;
  })
  @ValidateNested()
  @validateIf((options, value) => options.isMarried)
  override spouse?: IncomeTaxPersonalSpouseOptions;

  @array(IncomeTaxPersonalChildOptions)
  @advancedFormArray({
    emptyNumberOfChildrenFormToCreate: 0,
    elementClassType: IncomeTaxPersonalChildOptions,
  })
  @ValidateNested()
  override children: IncomeTaxPersonalChildOptions[] = [];
}
